import _ from "lodash";
import moment from "moment/moment";
import { addDays, eachDayOfInterval, intervalToDuration } from "date-fns";

import { QUERY_PARAM_NAMES } from "config";
import { getStationByNlc } from "services/StationsService";
import { getLocalStorageItem } from "./localStorage";
import DateTime from "../models/DateTime";

export const TIME_FORMAT = "HH:mm";

export const noop = () => {};

export const defer = (func, timeout = 0) => setTimeout(func, timeout);

export const countRailcards = (railcards) =>
  railcards.reduce((acc, railcard) => acc + railcard.quantity, 0);

export const durationToISO8601 = ({ start, end, includeLastDay = false }) => {
  const { months, days } = intervalToDuration({
    start,
    end: includeLastDay ? addDays(end, 1) : end,
  });

  return `P${months}M${days > 0 ? `${days}D` : ""}`;
};

export const getQueryParam = (name) => {
  const result = window.location.href.match(
    new RegExp("[?&]" + name + "=([^&]+)", "i")
  );

  if (result == null || result.length < 1) {
    return null;
  }
  return decodeURIComponent(result[1]);
};

export const getAllQueryParams = () => {
  const matches = window.location.href.matchAll(/[?&]([^=]+)=([^&]+)/gi);

  const params = [];

  for (const match of matches) {
    if (match[1] && match[2]) {
      params.push({ name: match[1], value: match[2] });
    }
  }

  return params;
};

export const getExternalQueryParams = () => {
  return getAllQueryParams().filter(
    (param) => !QUERY_PARAM_NAMES.includes(param.name)
  );
};

export const getEachDayOfInterval = ({ start, end, options = {} }) => {
  try {
    return eachDayOfInterval({
      start,
      end,
      options,
    });
  } catch (e) {
    return [];
  }
};

export const getDefaultStation = async (stationNlc, apiUrl, apiAccessToken) => {
  if (!stationNlc) {
    return null;
  }

  const station = await getStationByNlc(stationNlc, apiUrl, apiAccessToken);
  return _.pick(station, ["name", "nlc"]);
};

export const isPastDate = date => {
  const currentDate = moment();

  return moment(date).isBefore(currentDate);
}

export const getLastSearch = (localStorageKey) => {
  const lastSearch = getLocalStorageItem(localStorageKey);

  if (lastSearch) {
    if(lastSearch.fromDateTime) {
      const prevSearchFromDateTime = lastSearch.fromDateTime.dateTime;
      lastSearch.fromDateTime = isPastDate(prevSearchFromDateTime) ?
          new DateTime().addHours(1) :
          new DateTime(prevSearchFromDateTime);
    }

    if(lastSearch.toDateTime) {
      const prevSearchToDateTime = lastSearch.toDateTime.dateTime;
      lastSearch.toDateTime = isPastDate(prevSearchToDateTime) ?
          new DateTime().addHours(5) :
          new DateTime(prevSearchToDateTime);
    }
  }
  return lastSearch
}
